import { useQuery } from '@tanstack/react-query';

import { useSearch } from '@tanstack/react-router';
import { type FC, useMemo } from 'react';
import { RegionsPage } from '@/features/cartographie';
import { filterRegionsByTerritoire } from '@/libraries/collectivites';
import { inject } from '@/libraries/injection';
import { useFilteredSearchParams } from '@/shared/hooks';
import { TERRITOIRE_FILTER } from '@/shared/injection/keys/territoire-filter.key';
import { fetchTotalLieux } from '../api';

export const Page: FC = () => {
  const search = useSearch({ strict: false }) as Record<string, string>;
  const baseSearchParams = useMemo(() => new URLSearchParams(search), [search]);
  const searchParams = useFilteredSearchParams(baseSearchParams);
  const territoireFilter = inject(TERRITOIRE_FILTER);

  const filteredRegions = filterRegionsByTerritoire({
    territoire_type: territoireFilter.type,
    territoires: territoireFilter.codes
  });

  const { data: totalLieux = 0 } = useQuery({
    queryKey: ['stats', 'total', searchParams.toString()],
    queryFn: () => fetchTotalLieux(searchParams)
  });

  return <RegionsPage totalLieux={totalLieux} regions={filteredRegions} />;
};
